import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import { BasicSelect,ModelSelect} from 'vue-search-select';
import download from 'downloadjs';
import DatePicker from 'vue2-datepicker'
import Paginate from 'vuejs-paginate'
import { PDFDocument } from 'pdf-lib'
import Printd from 'printd';
import VueBarcode from 'vue-barcode';

export default {
name: 'RtoShipmentpage',
components: {
  BasicSelect,
  ModelSelect,
  VueElementLoading,
  download,
  DatePicker,
  Paginate,
  barcode: VueBarcode
},
props: [],
data() {
return {
  AWBnumber:'',
  RTOAWB:'',
  RTONotificationDate:'',
  OriginHubName:'',
  originhub:'',
  destinationhubs:'',
  DestinationHubName:'',
  ParentAWB:'',
  MPSCount:'',
  PhysicalWeight:'',
  pageCount:0,
  pageNo: 1,
  limit: 10,
  totalrecoreds:0,
  awbLoading:false,
  exportLoading:false,
  popLoader:false,
  Branchloading:'',
  AWBResponse:[],
  showModal:false,
  Printdata: [],
  currentHubId:0,
  showMPSID:false,
  mpsArray:[],
  SRNNo:[],
  Ewaybill:[],
  MPSIDs:[],
  prnData:'',
  PrintMpsData:'',
  showdetails:true,
  bookingmode:'',
  NonDOX :'',
  DOX :'',
  awbNo:'',
  chargedwt: '',
  bookingData:{},
  totalRows:0,
  copy:[{value:"SHIPPER COPY"},{value:"ACCOUNT COPY"},{value:"POD COPY"},{value:"CONSIGNEE COPY"}],
  AWBNumberError:false,
  AWBErrorMsg:''
  }
},
computed: {},
filters: {
moment: function(date) {
  if (date == null || date == '')
  return '--'
  return moment(date).format('DD-MM-YYYY HH:mm:ss');
  }
},
mounted() {
  var userdetailEncrypt = window.localStorage.getItem('userdetail')
  var bytes             = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
  var plaintext         = bytes.toString(CryptoJS.enc.Utf8);
  var userdetail        = JSON.parse(plaintext);
  this.useremail        = userdetail[0].email;
  this.currentHubId     = userdetail[0].HubId[0];
  this.getCargoAWBDetails()
},
methods: {
/* GET AWBsearch API*/
getCargoAWBDetails(){
  this.awbLoading = true;
  this.totalRows = 0;
  this.AWBResponse = [];
  this.input = {
    "HubID": this.currentHubId,
    "offset": this.pageNo,
    "limit": 10
  }
  if(this.AWBnumber!=''){
    this.input["AWBNumber"]=this.AWBnumber
  }
  axios({
    method: 'POST',
    url: apiUrl.api_url_hubops + 'CargoRTOPrintingAWBList',
    data: this.input,
    headers: {
      'authorization': 'authkey xB84JJ89Hd25',
    }
  })
  .then(result => {
    if (result.data.ResultCode == 100) {
      this.AWBResponse = result.data.Details
       this.totalRows = result.data.FullCount
      if (this.totalRows < this.limit) {
        this.pageCount = 1
      } else {
        this.pageCount = Math.ceil(this.totalRows / this.limit);
      }
  }else{
    this.$alertify.error(result.data.ReturnMessage, "", "error");
    }
    this.awbLoading = false;
  }, error => {
    this.awbLoading = false;
    console.error(error);
  })
},

exportRtoShipmentCsv() {
  if (this.totalRows < 1) {
    return;
  }

  this.exportLoading = true;
  const payload = {
    HubID: this.currentHubId,
    AWBNumber: this.AWBnumber || '',
    ExportAll: true,
  };

  axios({
    method: 'POST',
    url: apiUrl.api_url_hubops + 'CargoRTOPrintingAWBList',
    data: payload,
    headers: {
      'authorization': 'authkey xB84JJ89Hd25',
    }
  })
  .then(result => {
    if (result.data.ResultCode === 100) {
      const rows = result.data.Details || [];
      if (!rows.length) {
        this.$alertify.error('No shipments found for export');
        return;
      }

      const headers = [
        'RTO AWB',
        'RTO Notification Date',
        'Origin',
        'Destination',
        'Parent AWB (Forward AWB)',
        'MPS Count',
        'Physical Weight(kg)'
      ];
      const csvLines = [
        headers.join(','),
        ...rows.map((row) => [
          row.RTOAWB,
          row.RTONotificationDate ? moment(row.RTONotificationDate).format('DD-MM-YYYY HH:mm:ss') : '--',
          row.OriginHubName,
          row.DestinationHubName,
          row.ParentAWB,
          row.MpsCount,
          row.PhysicalWeight
        ].map((cell) => `"${String(cell != null ? cell : '').replace(/"/g, '""')}"`).join(','))
      ];
      const blob = new Blob([csvLines.join('\n')], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `B2B_RTO_DestinationChange_${this.currentHubId}_${moment().format('YYYYMMDD')}.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      this.$alertify.success(`Exported ${rows.length} shipment(s)`);
    } else if (result.data.ResultCode === 101) {
      this.$alertify.error(result.data.ReturnMessage || 'No shipments found for export');
    } else {
      this.$alertify.error(result.data.ReturnMessage || 'Export failed');
    }
  }, error => {
    console.error(error);
    this.$alertify.error('Error exporting shipments');
  })
  .then(() => {
    this.exportLoading = false;
  });
},

showMPSDetails(data){
  let obj = this.AWBResponse.find(o => o.ParentAWB == data);
  this.mpsArray = obj.MPSIDs;
  this.showMPSID =true
},
/*print document and view or pdf print API*/
getCargoPrintAWBDetails(rtoawb){
  this.input = {
    AWBNumber:rtoawb
  }
    this.RTOAWB=rtoawb
    this.awbLoading = true;
  axios({
    method: 'POST',
    url: apiUrl.api_url_hubops + 'CargoRTOPrintDocument',
    data: this.input,
    headers: {
      'authorization': 'authkey xB84JJ89Hd25',
    }
  })
  .then(result => {
    this.awbLoading = false;
    if (result.data.ResultCode == 100) {
      this.Printdata= result.data.Details
      this.SRNNo= this.Printdata.SalesReturnNote
      this.Ewaybill= this.Printdata.EWayBill
      this.MPSIDs= this.Printdata.MPSIDs
      this.showModal= true
  }else{
    this.$alertify.error(result.data.ReturnMessage, "", "error");
    }
  }, error => {
    console.error(error);
    this.awbLoading = false;
  })
},
getSRNLink(index,type){
  if(type == 'srnno'){
    return this.SRNNo[index]
  }else{
    return this.Ewaybill[index]
  }
},

//pagination data
getPaginationData(pageNum) {
  this.pageNo = pageNum;
  this.getCargoAWBDetails()
},

// AWB function search
AWBSubmit: function() {
  if(this.AWBnumber == ''){
    this.AWBErrorMsg ='Please Enter AWB No'
    this.AWBNumberError = true
    return
  }
    this.pageNo = 1
    this.RTOAWB =''
    this.Origin = ''
    this.Destination = ''
    this.MPSCount = ''
    this.PhysicalWeight =''
    this.ParentAWB =''
    this.RTONotificationDate = ''
    this.AWBErrorMsg =''
    this.AWBNumberError = false
    this.getCargoAWBDetails();
},
 refresh(){
  this.pageNo = 1,
  this.AWBnumber ='',
  this.AWBResponse = [],
  this.AWBErrorMsg =''
  this.AWBNumberError = false
  this.$refs.paginate.selected = 0;
  this.getCargoAWBDetails()
},

closeModal() {
  this.showModal = false;
  $(document.body).removeClass("modal-open");
  $(".modal-backdrop").remove();
},
closeModalMPSID() {
  this.showMPSID = false;
  $(document.body).removeClass("modal-open");
  $(".modal-backdrop").remove();
},

async bulkPDFPrint(awb){
  this.input = {
    AWBNumber:awb,
    SearchType: "parentawb",
    offset: 0
  }
    this.popLoader = true;
  axios({
    method: 'POST',
    url: apiUrl.api_url_hubops + 'CargoRTOPrintMPSSticker',
    data: this.input,
    headers: {
      'authorization': 'authkey xB84JJ89Hd25',
    }
  })
  .then(result => {
    this.popLoader = false;
    if (result.data.ResultCode == 100) {
      this.PrintMpsData= result.data.Details
      let str = '';
      let awbnumber = this.PrintMpsData.parentawbno;
      let originhub = this.PrintMpsData.OriginHubName;
      let destinationhubs = this.PrintMpsData.DestinationHubName;
      let totalmps = this.PrintMpsData.noofmps;
      for (var i = 0; i < this.PrintMpsData.childmps.length; i++) {
      let childawb = this.PrintMpsData.childmps[i].childmpsno;
      let sequence = i+1;
      str = str.concat(
        // 'n\n' +
        //     'M0751\n' +
        //     'KI70\n' +
        //     'O0220\n' +
        //     'V0\n' +
        //     'f303\n' +
        //     'D\n' +
        //     'L\n' +
        //     'D11\n' +
        //     'A2\n' +
        //     '1X1100000010030L001300\n' +
        //     '1e6305002090036B' + childawb + '\n' +
        //     '1911A1201900106' + childawb + '\n' +
        //     '1911A1201500079Source :' + originhub + '\n' +
        //     '1911A1201120079Destination :' + destinationhubs + '\n' +
        //     '1911A1200710079Pieces:' + sequence + '/' + totalmps + '\n' +
        //     '1911A1202710079www.xpressbees.com' + '\n' +
        //     '4911A1000880025' + awbnumber + '\n' +
        //     'Q0001\n' +
        //     'E'
        `^XA
        ^SZ2^JMA
        ^MCY^PMN
        ^PW812
        ~SD12^MD0^MTD
        ~JSN
        ~SD25^MD0
        ^JZY
        ^LH0,0^LRN
        ^XZ
        ^XA
        ^FO84,5
        ^GB0,584,3^FS
        ^FT64,465
        ^CI0
        ^A0B,25,34^FD${awbnumber}^FS
        ^FT123,56
        ^A0N,25,34^FDWWW.XPRESSBEES.COM^FS
        ^FO109,83
        ^BY2^BCN,73,N,N^FD>:${childawb}^FS
        ^FT131,181
        ^A0N,25,34^FD${childawb}^FS
        ^FT135,349
        ^A0N,25,34^FDDestination :^FS
        ^FT320,351
        ^A0N,25,34^FD${destinationhubs}^FS
        ^FT138,292
        ^A0N,25,34^FDSource :^FS
        ^FT262,294
        ^A0N,25,34^FD${originhub}^FS
        ^FT136,410
        ^A0N,25,34^FDPieces :^FS
        ^FT257,410
        ^A0N,25,34^FD${sequence + '/' + totalmps}^FS
        ^PQ1,0,1,Y
        ^XZ`
      );
      this.prnData = str;
      console.log(this.prnData);
    }
      this.popLoader = false;
      this.printerSticker(this.prnData);
  }else{
    this.$alertify.error(result.data.ReturnMessage, "", "error");
    }
  }, error => {
    console.error(error);
    this.popLoader = false;
  })
},
 /* print sticker API */
printerSticker(prnData) {
  this.input = {
    prnData: prnData,
    bagNumber: moment().format('DD-MM-YYYY')
  }
    this.awbLoading = true;
  axios({
    method: "POST",
    url: "http://localhost:4500/printer/printbagsticker",
    data: this.input,
  })
  .then(result => {
    if (result.data.ResultCode == 100) {
      this.$alertify.success(result.data.ReturnMessage);
      this.$validator.reset();
      this.errors.clear();
  } else {
    this.$alertify.error(result.data.ReturnMessage);
  }
  }, error => {
    var code = error.response == undefined ? code = 0 : error.response.status;
    if (code == 500) {
      this.$alertify.error("Printer API error");
      console.log(error.response.statusText);
  } else if (error) {
      this.$alertify.error("Printer not connected")
    }
  })
      this.awbLoading = false;
},

DownloadAWB(){
  const contentHtml = document.getElementById('printAWBData').innerHTML;
  var html = htmlToPdfmake(contentHtml);
  var docDefinition = {
    content: [html],
    styles:{
      'with-margin':{
      marginLeft: 30 // apply a margin with the specific class is used
      }
    }
  };
  pdfMake.createPdf(docDefinition).download();
},
/* print AWB PDF API */
printRTOAWBPDF(rtoawb) {
  this.popLoader = true;
  this.input = {
    "AWBNumber":rtoawb
  }
  axios({
    method: 'POST',
    url: apiUrl.api_url_hubops + 'CargoRTOPrintAWBPDF',
    data: this.input,
    headers: {
    'authorization': 'authkey xB84JJ89Hd25',
    }
  })
  .then(result => {
    this.popLoader = false;
    if (result.data.ResultCode == 100) {
    this.bookingData = result.data.Details;
    this.awbNo = this.bookingData.awbnumber;
    if (this.bookingData.bookingmode.toLowerCase() == 'to pay' || this.bookingData.bookingmode.toLowerCase() == 'topay') {
    this.bookingmode = 'FTC'
  }else {
    this.bookingmode = this.bookingData.bookingmode
  }
  }else{
    this.$alertify.error(result.data.ReturnMessage, "", "error");
  }
  },
  error => {
    console.error(error);
    this.popLoader = false;
  }).then(printresult =>{
    this.createandprintPDF()
  })
},
createandprintPDF(){
  const d = new Printd();
  var buffer = '';

  var cssText = `
  body{
      -webkit-print-color-adjust:exact;
      font-family: Roboto,sans-serif;
      font-size:20%;
    }
    table {
      border-collapse: collapse;
      margin-left:0px !important;
    }
    table, td, th {
      border-style: solid;
      border-width: 1px;
      padding:5px;
    }
    .text-right{
      text-align:right;
    }
    .text-left{
      text-align:left;
    }
    .text-center{
      text-align:center;
    }
    .h3-center-text{
      text-align:center;
    }
    @media print {
      .text-primary th{
      background-color:rgb(226, 216, 216) !important;
      color:black !important;
      font-size:20px !important;
    }
  }
  @media print {
    h3 {
    page-break-after: always;
    }
  }
  `
  d.print(document.getElementById('printAWBData'), cssText);
},

/* Convert the merged pdf array buffer to blob url for print or open in browser.*/
downloadFile(data) {
  const blob = new Blob([data], { type: 'application/pdf'});
  const url= window.URL.createObjectURL(blob);
  this.printPDFA(url);
},
async readMergePDF(pdfsToMerge) {
/* Array of pdf urls */
  this.popLoader = true;
  let otherFormateDoc = [];
    const mergedPdf = await PDFDocument.create();
      for (const pdfCopyDoc of pdfsToMerge) {
        if(pdfCopyDoc.match(".+\.pdf$")){
        otherFormateDoc.push(pdfCopyDoc)
        const pdfBytes = await fetch(pdfCopyDoc).then(res => res.arrayBuffer(),
        error => {
         console.error(error);
         this.popLoader = false;
         return this.$alertify.error("Access Error");
       })
        const pdf = await PDFDocument.load(pdfBytes);
        const copiedPages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
          copiedPages.forEach((page) => {
          mergedPdf.addPage(page);
          });
        }
      }
      this.popLoader = false;
    if (otherFormateDoc.length<=0) {
    return this.$alertify.error("error: Only .pdf Document Allow");
    }
    const mergedPdfFile = await mergedPdf.save();
    this.downloadFile(mergedPdfFile);
},
printPDFA(url){
  var iframe = document.createElement('iframe');
  // Hide the IFrame.
  iframe.style.visibility = "hidden";
  // Define the source.
  iframe.src = url;

  iframe.onload = function(){
    iframe.contentWindow.focus(); // Set focus.
    iframe.contentWindow.print(); // Print it
  };
  document.body.appendChild(iframe);
},
resetForm() {
  this.AWBnumber='',
  this.totalrecoreds=0,
  this.AWBResponse =[],
  this.Printdata= [],
  this.showMPSID= false,
  this.mpsArray= [],
  this.SRNNo= [],
  this.Ewaybill= [],
  this.MPSIDs= [],
  this.prnData='',
  this.PrintMpsData='',
  this.totalRows=0,
  this.showdetails= true,
  this.bookingmode='',
  this.mergedPdfFile='',
  this.AWBErrorMsg =''
  this.AWBNumberError = false
  this.exportLoading = false
  this.$validator.reset();
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/RtoShipmentPageDashboard/RtoShipmentPageDashboard.component.js